import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {LoggedUser, User} from './logged-user.service';
import {map} from 'rxjs/operators';


export const SUPER_ADMIN = {requiredRole: 'ROLE_SUPER_ADMIN'};
export const ADMIN = {requiredRole: 'ROLE_ADMIN'};
export const OPERATOR = {requiredRole: 'ROLE_OPERATOR'};
export const VIEWER = {requiredRole: 'ROLE_VIEWER'};

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  private hierarchy = ['ROLE_VIEWER', 'ROLE_OPERATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];
  readonly notFoundPath = '/not-found';
  readonly notAuthorizedPath = '/not-authorized';

  private userRole: string;

  constructor(private router: Router,
              private loggedUser: LoggedUser) {
    loggedUser.userObservable.subscribe( user => {
      this.userRole = this.extractRole(user);
      if ('NO_ROLE' === this.userRole) {
        this.router.navigate([this.notAuthorizedPath]).finally();
      }
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userRole === undefined) {
      return this.loggedUser.userObservable.asObservable().pipe(
        map( (user: User) => {
          return this.hasRequiredRole(next.data);
        })
      );
    } else {
      return this.hasRequiredRole(next.data);
    }

  }

  hasRequiredRole(requiredRole: any): boolean | UrlTree {
    if ('NO_ROLE' === this.userRole) {
      return this.router.parseUrl(this.notAuthorizedPath);
    }
    return (this.hierarchy.indexOf(this.userRole) >= this.hierarchy.indexOf(requiredRole.requiredRole)) ?
      true : this.router.parseUrl(this.notFoundPath);
  }

  superAdminRequired(): boolean {
    return this.minRole(SUPER_ADMIN.requiredRole);
  }

  adminRequired(): boolean {
    return this.minRole(ADMIN.requiredRole);
  }

  operatorRequired(): boolean {
    return this.minRole(OPERATOR.requiredRole);
  }

  viewerRequired(): boolean {
    return this.minRole(VIEWER.requiredRole);
  }

  minRole(requiredRole: string): boolean {
    return (this.hierarchy.indexOf(this.userRole) >= this.hierarchy.indexOf(requiredRole));
  }

  extractRole(user: User): string {
    return user.role === undefined ? 'NO_ROLE' : user.role;
  }
}
